import { Injectable } from '@angular/core';
import { AppConst } from '../common/app.constants';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private apiService: ApiService) {}

  setAccountLogin() {
    this.apiService.get('/api/account/GetInfoAccountLogin').subscribe({
      next: (response: any) => {
        if (response && response.data) {
          localStorage.setItem(
            AppConst.ROLE_USER,
            JSON.stringify(response.data[0])
          );
        }
      },
    });
  }

  get isAdmin(): boolean {
    const value: string = localStorage.getItem(AppConst.ROLE_USER);
    if (value) {
      const user = JSON.parse(value);
      let roleAccess = user.ROLE_ACCESS;
      let is_admin = user.IS_ADMIN;
      if (roleAccess == 50 || is_admin == 1 || roleAccess == 53) {
        return true;
      }
    }
    return false;
  }
}
